import React from "react";
import { useSearchParams } from "react-router-dom";

const NativeAppPage: React.FC = () => {
    const [searchParams, setSearchParams] = useSearchParams();
    const iframeSource = `/app?${searchParams.toString()}`;
    //const iframeSource = `../../web-app-env/public_html/index.html?${searchParams.toString()}`;

    React.useEffect(() => {
        document.title=`DimensionX | Scene Editor`;
    }, []);

    return (
        <iframe src={iframeSource}></iframe>
    );
};

export default NativeAppPage;
